import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

export function ProtectedRoute({ children, adminOnly = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user, checkAuth, logout } = useAuthStore();
  const location = useLocation();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const verify = async () => {
      // トークンがlocalStorageにあるか確認
      const token = localStorage.getItem('token');
      if (!token) {
        // トークンがなければログアウト状態にして完了
        logout();
        setChecked(true);
        return;
      }

      // トークンがあればサーバーで有効性を確認
      await checkAuth();
      setChecked(true);
    };

    verify();
  }, []);

  // 確認中はローディング表示
  if (!checked || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
      </div>
    );
  }

  // 未認証ならログインページへ
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 管理者専用ページのチェック
  if (adminOnly && user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
